<script setup lang="ts">
import { useAuth } from "@features/authentication/composables";
import { USER_MENU } from "@shared/constants/navigations";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@ui/hover-card";
import { RouterLink } from "vue-router";

const { authenticated } = useAuth();
</script>

<template>
  <template v-if="authenticated">
    <HoverCard :open-delay="0">
      <HoverCardTrigger as-child>
        <RouterLink to="/my-account" class="group hidden cursor-pointer text-content lg:block">
          <img
            src="@assets/images/icons/icon-account.webp"
            width="20"
            height="20"
            alt="User account icon"
            class="group-hover:hidden"
          />
          <img
            src="@assets/images/icons/icon-account-hover.webp"
            width="20"
            height="20"
            alt="User account icon"
            class="hidden group-hover:block"
          />
        </RouterLink>
      </HoverCardTrigger>
      <HoverCardContent :align="'end'" :side-offset="15">
        <nav class="flex flex-col gap-4 text-label">
          <RouterLink v-for="menu in USER_MENU" :key="menu.name" :to="menu.path">
            {{ menu.name }}
          </RouterLink>
        </nav>
      </HoverCardContent>
    </HoverCard>
  </template>
  <template v-else>
    <RouterLink to="/my-account" class="group hidden lg:block">
      <img
        src="@assets/images/icons/icon-account.webp"
        width="20"
        height="20"
        alt="User account icon"
        class="group-hover:hidden"
      />
      <img
        src="@assets/images/icons/icon-account-hover.webp"
        width="20"
        height="20"
        alt="User account icon"
        class="hidden group-hover:block"
      />
    </RouterLink>
  </template>
</template>
